import Signal from '@signals/Signal.js';

export const resizingDrawer = new Signal();
export const resizingPreview = new Signal();
export const projectListUpdated = new Signal();
